import * as ActionTypes from '../action-types';
import produce from 'immer';
import { AUTH_TOKEN, USER } from '../../constants';
import Axios from 'axios';

const user = {
  id: null,
  name: null,
  email: null,
  createdAt: null,
  updatedAt: null,
  isAdmin: false,
  isCustomer: null
};

const initialState = {
  isAuthenticated: false,
  loading: false,
  error: '',
  user
};

const Auth = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case ActionTypes.AUTH_CHECK:
      return checkAuth(state);

    case ActionTypes.UPDATE_USER_LOCAL_STORAGE:
      return updateUserLocalStorage(state, payload);
    // Added for laravel 7
    case ActionTypes.UPDATE_USER_NAME_LOCAL_STORAGE:
      return updateUserNameLocalStorage(state, payload);
    case ActionTypes.SAVE_USER:
      return { ...state, user: payload };
    case ActionTypes.LOGIN_LOADING:
      return { ...state, loading: true, error: '' };
    case ActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        loading: false
      };
    case ActionTypes.LOGIN_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        error: payload
      };
    case ActionTypes.LOGOUT:
      return { ...initialState, error: state.error };
    default:
      return state;
  }
};

const checkAuth = state => {
  const localUser = JSON.parse(localStorage.getItem(USER));
  state = Object.assign({}, state, {
    isAuthenticated: localUser ? localUser.email : false,
    user: localStorage.getItem(USER)
      ? JSON.parse(localStorage.getItem(USER))
      : { ...initialState.user }
  });

  return state;
};

const updateUserNameLocalStorage = (state, firstName) => {
  const nextState = produce(state, ns => {
    ns.user.first_name = firstName;
  });

  localStorage.setItem(USER, JSON.stringify(nextState.user));

  return nextState;
};

const updateUserLocalStorage = (state, user) => {
  localStorage.setItem(USER, JSON.stringify(user));
  state = Object.assign({}, state, {
    user: user
  });

  return state;
};

export default Auth;
